export default __webpack_public_path__ + "static/media/68_photo.9f452468.jpg";